
import { Helmet } from "react-helmet";
import FaqAccordionTwo from "../components/common/faq/faq-accordion-two";
import ClientSliderOne from "../components/common/sliders/client/client-slider-one";
import VideoSectionFour from "../components/common/video/video-section-four";
import CtaSection from "../components/home-five/cta-section";
import FeatureSection from "../components/home-five/feature-section";
import HeroSection from "../components/home-five/hero-section";
import TestimonialSection from "../components/home-five/testimonial-section";
import WalletSection from "../components/home-five/wallet-section";

export default function HomeFive() {
	return (
		<>
			<Helmet>
				<title>fugu - index -05</title>
			</Helmet>
			<HeroSection />
			<ClientSliderOne />
			<VideoSectionFour />
			<FeatureSection />
			<WalletSection />
			<TestimonialSection />
			<FaqAccordionTwo />
			<CtaSection />
		</>
	);
}
